import PT from 'prop-types';
import IPT from 'react-immutable-proptypes';
import { STATUS, FAILURE_REASON, NODE_TYPE } from './constants';

// See tod_django/course/serializers.py for back-end equivalents

export const statusPropTypes = PT.oneOf(Object.values(STATUS));

export const failureReasonPropTypes = PT.oneOf(
  Object.values(FAILURE_REASON).concat([''])
);

export const coursePropTypes = IPT.contains({
  id: PT.number.isRequired,
  is_published: PT.bool.isRequired,
  slug: PT.string.isRequired,
  title: PT.string.isRequired,
});

export const sectionPropTypes = IPT.contains({
  id: PT.number.isRequired,
  title: PT.string.isRequired,
});

export const examPropTypes = IPT.contains({
  id: PT.number.isRequired,
  is_published: PT.bool.isRequired,
  is_submittable: PT.bool.isRequired,
  question_count: PT.number.isRequired,
  title: PT.string.isRequired,
  marks_total: PT.string.isRequired,
});

export const chunkPropTypes = IPT.contains({
  id: PT.number.isRequired,
  title: PT.string.isRequired,
  total_duration: PT.number.isRequired,
  index: PT.number.isRequired,
});

export const lessonPropTypes = IPT.contains({
  id: PT.number.isRequired,
  title: PT.string.isRequired,
  question_set: examPropTypes,
  is_published: PT.bool,
  total_duration: PT.number.isRequired,
  chunks: IPT.listOf(chunkPropTypes),
});

export const nodePropTypes = IPT.contains({
  id: PT.string.isRequired,
  node_type: PT.oneOf(Object.values(NODE_TYPE)).isRequired,
  value_id: PT.oneOfType([PT.string, PT.number]).isRequired,
});

export const assemblagePropTypes = IPT.contains({
  content: IPT.mapContains({
    exams: IPT.mapOf(examPropTypes, PT.string).isRequired,
    lessons: IPT.mapOf(lessonPropTypes, PT.string).isRequired,
    sections: IPT.mapOf(sectionPropTypes, PT.string).isRequired,
  }),
  // these can be empty. Need to work out how to validate empty map or some other thing
  course: IPT.map, // see coursePropTypes above
  node: IPT.map,
});

export const studentPropType = IPT.contains({
  user_id: PT.number.isRequired,
  profile_id: PT.number.isRequired,
  display_name: PT.string.isRequired,
  last_name: PT.string.isRequired,
});

export const classDetailPropType = IPT.contains({
  course_id: PT.number.isRequired,
  title: PT.string.isRequired,
  students: IPT.listOf(studentPropType).isRequired,
});
